module.exports = __webpack_public_path__ + "static/media/revision@2x.f98a4bde.png";